import {ICharDiscipline} from "../../_interfaces/ICharDiscipline";
import disziplinen from "../../_data/disziplinen";
import {IDataDisciplineBonus, IDataDisciplineDefence} from "../../_interfaces/IDataDiscipline";
import {ModsAdd, ModsSourceDelete} from "../../_api/BEMods";
import {s_char} from "../../_signals/s_char";
import {ICharMod} from "../../_interfaces/ICharMod";
import {v4} from "uuid";

export const raiseMods = (discipline: ICharDiscipline, newCircle: number) => {
    const disz = disziplinen.find(d => d.name == discipline.id)
    if (disz) {
        const b = disz.TuF[newCircle].b as IDataDisciplineBonus;
        const v = disz.TuF[newCircle].v as IDataDisciplineDefence;

        ModsSourceDelete(s_char.value.id, 'discipline', discipline.id)
        let mods: ICharMod[] = [];
        if (b.mr > 0) {
            mods.push({
                id: v4(),
                cid: s_char.value.id,
                msourceid: discipline.id,
                sl: false,
                strain: 0,
                msource: 'discipline',
                mfrom: discipline.name,
                what: 'mr',
                mmod: b.mr,
                type: 'constant',
                duration: 0,
                disabled: true
            })
        }
        if (b.ep > 0) {
            mods.push({
                id: v4(),
                cid: s_char.value.id,
                msourceid: discipline.id,
                sl: false,
                strain: 0,
                msource: 'discipline',
                mfrom: discipline.name,
                what: 'ep',
                mmod: b.ep,
                type: 'constant',
                duration: 0,
                disabled: true
            })
        }
        if (v.k > 0) {
            mods.push({
                id: v4(),
                cid: s_char.value.id,
                msourceid: discipline.id,
                sl: false,
                strain: 0,
                msource: 'discipline',
                mfrom: discipline.name,
                what: 'kv',
                mmod: v.k,
                type: 'constant',
                duration: 0,
                disabled: true
            })
        }
        if (v.m > 0) {
            mods.push({
                id: v4(),
                cid: s_char.value.id,
                msourceid: discipline.id,
                sl: false,
                strain: 0,
                msource: 'discipline',
                mfrom: discipline.name,
                what: 'mv',
                mmod: v.m,
                type: 'constant',
                duration: 0,
                disabled: true
            })
        }
        if (v.s > 0) {
            mods.push({
                id: v4(),
                cid: s_char.value.id,
                msourceid: discipline.id,
                sl: false,
                strain: 0,
                msource: 'discipline',
                mfrom: discipline.name,
                what: 'sv',
                mmod: v.s,
                type: 'constant',
                duration: 0,
                disabled: true
            })
        }
        if (mods.length > 0) ModsAdd(s_char.value.id, mods)
    }
}
